/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as LogsRouteImport } from './routes/logs'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AlertsRouteImport } from './routes/alerts'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SecurityIndexRouteImport } from './routes/security/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SecurityTwoFactorRouteImport } from './routes/security/two-factor'
import { Route as SecurityTokensRouteImport } from './routes/security/tokens'
import { Route as SecuritySessionsRouteImport } from './routes/security/sessions'
import { Route as ProfileNotificationsRouteImport } from './routes/profile/notifications'
import { Route as ProfileDeleteRouteImport } from './routes/profile/delete'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminBillingRouteImport } from './routes/admin/billing'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'

const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const LogsRoute = LogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsRoute = AlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityIndexRoute = SecurityIndexRouteImport.update({
  id: '/security/',
  path: '/security/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityTwoFactorRoute = SecurityTwoFactorRouteImport.update({
  id: '/security/two-factor',
  path: '/security/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityTokensRoute = SecurityTokensRouteImport.update({
  id: '/security/tokens',
  path: '/security/tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const SecuritySessionsRoute = SecuritySessionsRouteImport.update({
  id: '/security/sessions',
  path: '/security/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileNotificationsRoute = ProfileNotificationsRouteImport.update({
  id: '/profile/notifications',
  path: '/profile/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileDeleteRoute = ProfileDeleteRouteImport.update({
  id: '/profile/delete',
  path: '/profile/delete',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBillingRoute = AdminBillingRouteImport.update({
  id: '/admin/billing',
  path: '/admin/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/analytics': typeof AnalyticsRoute
  '/logs': typeof LogsRoute
  '/projects': typeof ProjectsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/profile/delete': typeof ProfileDeleteRoute
  '/profile/notifications': typeof ProfileNotificationsRoute
  '/security/sessions': typeof SecuritySessionsRoute
  '/security/tokens': typeof SecurityTokensRoute
  '/security/two-factor': typeof SecurityTwoFactorRoute
  '/admin/': typeof AdminIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/security/': typeof SecurityIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/analytics': typeof AnalyticsRoute
  '/logs': typeof LogsRoute
  '/projects': typeof ProjectsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/profile/delete': typeof ProfileDeleteRoute
  '/profile/notifications': typeof ProfileNotificationsRoute
  '/security/sessions': typeof SecuritySessionsRoute
  '/security/tokens': typeof SecurityTokensRoute
  '/security/two-factor': typeof SecurityTwoFactorRoute
  '/admin': typeof AdminIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/security': typeof SecurityIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/analytics': typeof AnalyticsRoute
  '/logs': typeof LogsRoute
  '/projects': typeof ProjectsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/profile/delete': typeof ProfileDeleteRoute
  '/profile/notifications': typeof ProfileNotificationsRoute
  '/security/sessions': typeof SecuritySessionsRoute
  '/security/tokens': typeof SecurityTokensRoute
  '/security/two-factor': typeof SecurityTwoFactorRoute
  '/admin/': typeof AdminIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/security/': typeof SecurityIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/alerts'
    | '/analytics'
    | '/logs'
    | '/projects'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/settings'
    | '/profile/delete'
    | '/profile/notifications'
    | '/security/sessions'
    | '/security/tokens'
    | '/security/two-factor'
    | '/admin/'
    | '/profile/'
    | '/security/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alerts'
    | '/analytics'
    | '/logs'
    | '/projects'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/settings'
    | '/profile/delete'
    | '/profile/notifications'
    | '/security/sessions'
    | '/security/tokens'
    | '/security/two-factor'
    | '/admin'
    | '/profile'
    | '/security'
  id:
    | '__root__'
    | '/'
    | '/alerts'
    | '/analytics'
    | '/logs'
    | '/projects'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/settings'
    | '/profile/delete'
    | '/profile/notifications'
    | '/security/sessions'
    | '/security/tokens'
    | '/security/two-factor'
    | '/admin/'
    | '/profile/'
    | '/security/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AlertsRoute: typeof AlertsRoute
  AnalyticsRoute: typeof AnalyticsRoute
  LogsRoute: typeof LogsRoute
  ProjectsRoute: typeof ProjectsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminBillingRoute: typeof AdminBillingRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  ProfileDeleteRoute: typeof ProfileDeleteRoute
  ProfileNotificationsRoute: typeof ProfileNotificationsRoute
  SecuritySessionsRoute: typeof SecuritySessionsRoute
  SecurityTokensRoute: typeof SecurityTokensRoute
  SecurityTwoFactorRoute: typeof SecurityTwoFactorRoute
  AdminIndexRoute: typeof AdminIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  SecurityIndexRoute: typeof SecurityIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logs': {
      id: '/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof LogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts': {
      id: '/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security/': {
      id: '/security/'
      path: '/security'
      fullPath: '/security/'
      preLoaderRoute: typeof SecurityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security/two-factor': {
      id: '/security/two-factor'
      path: '/security/two-factor'
      fullPath: '/security/two-factor'
      preLoaderRoute: typeof SecurityTwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security/tokens': {
      id: '/security/tokens'
      path: '/security/tokens'
      fullPath: '/security/tokens'
      preLoaderRoute: typeof SecurityTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security/sessions': {
      id: '/security/sessions'
      path: '/security/sessions'
      fullPath: '/security/sessions'
      preLoaderRoute: typeof SecuritySessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/notifications': {
      id: '/profile/notifications'
      path: '/profile/notifications'
      fullPath: '/profile/notifications'
      preLoaderRoute: typeof ProfileNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/delete': {
      id: '/profile/delete'
      path: '/profile/delete'
      fullPath: '/profile/delete'
      preLoaderRoute: typeof ProfileDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing': {
      id: '/admin/billing'
      path: '/admin/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlertsRoute: AlertsRoute,
  AnalyticsRoute: AnalyticsRoute,
  LogsRoute: LogsRoute,
  ProjectsRoute: ProjectsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminBillingRoute: AdminBillingRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  ProfileDeleteRoute: ProfileDeleteRoute,
  ProfileNotificationsRoute: ProfileNotificationsRoute,
  SecuritySessionsRoute: SecuritySessionsRoute,
  SecurityTokensRoute: SecurityTokensRoute,
  SecurityTwoFactorRoute: SecurityTwoFactorRoute,
  AdminIndexRoute: AdminIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  SecurityIndexRoute: SecurityIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
